// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "container-20qEe";
var _4 = "identity-36BIG";
var _5 = "field_middleName-2XHgC";
var _6 = "documents-1w1pN";
export { _1 as "__esModule", _2 as "tablet", _3 as "container", _4 as "identity", _5 as "field_middleName", _6 as "documents" }
export default { "__esModule": _1, "tablet": _2, "container": _3, "identity": _4, "field_middleName": _5, "documents": _6 }
